<div class="wrapper" *ngIf="!hideUI">
  <div *ngIf="isVisible" class="d-flex align-items-center gap-2">
    <div
      class="mx-auto"
      [ngClass]="currentClass"
      style="
        position: fixed;
        left: 50%;
        top: 8px;
        transform: translateX(-50%);
        z-index: 10500;
        pointer-events: auto;
      "
    >
      <span [class]="messageTextClass" style="font-size: 16px !important">
        &nbsp;
        <i [class]="icon"></i>
        &nbsp;
        <b> {{ currentMessage }} </b>&nbsp;&nbsp;
         <a 
            *ngIf="this.path"
            (click)="handlerGo()" 
            style="cursor: pointer; text-decoration: none;"
          >
           Go
          </a>
          <a 
            *ngIf="this.reload"
            (click)="handlerReload()" 
            class="reload-link"
          >
           Reload
          </a>
      </span>
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      <button
        type="button"
        class="btn-close me-2 m-auto"
        data-bs-dismiss="toast"
        aria-label="Close"
        (click)="close()"
      ></button>
    </div>
  </div>
  <ng-container>
    <app-sidebar />
    <app-topbar
      (settingsButtonClicked)="onSettingsButtonClicked()"
      (mobileMenuButtonClicked)="onToggleMobileMenu()"
    />
  </ng-container>
  <div class="page-content">
    <img
      src="assets/caregenix/images/logo/SVG-Carevance-Watermark.svg"
      alt="Watermark"
      class="dashboard-watermark-logo"
    />
    <div class="page-container">
      <ng-progress
        #progressBar
        [trickleSpeed]="10"
        [speed]="10"
        [spinner]="false"
        [thick]="true"
        color="#18978F"
        [ease]="'linear'"
      ></ng-progress>
      <router-outlet />
    </div>
  </div>
</div>

<div class="wrapper diff" *ngIf="hideUI">
  <!-- <div *ngIf="isVisible" class="d-flex align-items-center gap-2"> -->
    <!-- <div
      class="mx-auto"
      [ngClass]="currentClass"
      style="
        position: fixed;
        left: 50%;
        top: 8px;
        transform: translateX(-50%);
        z-index: 10500;
        pointer-events: auto;
      "
    >
      <span [class]="messageTextClass" style="font-size: 16px !important">
        &nbsp;
        <i [class]="icon"></i>
        &nbsp;
        <b> {{ currentMessage }} </b>
      </span>
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      <button
        type="button"
        class="btn-close me-2 m-auto"
        data-bs-dismiss="toast"
        aria-label="Close"
        (click)="close()"
      ></button>
    </div>
  </div> -->
  <app-top-bar-2
    (settingsButtonClicked)="onSettingsButtonClicked()"
    (openOnboardingOverview)="onOpenOnboardingOverview($event)"
  />
  <div class="page-content-full">
    <!-- <img
      src="assets/caregenix/images/logo/SVG-Carevance-Watermark.svg"
      alt="Watermark"
      class="dashboard-watermark-logo"
    /> -->

    <div class="page-container align">
      <ng-progress
        #progressBar
        [trickleSpeed]="10"
        [speed]="10"
        [spinner]="false"
        [thick]="true"
        color="#18978F"
        [ease]="'linear'"
      ></ng-progress>
      <router-outlet />
    </div>
  </div>
</div>
